var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeCharacter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.474609,
    width: 32.5898,
    height: 32.5898,
    rx: 6.51797,
    fill: "#EDF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 11.8836C15.7002 11.5049 15.9007 11.1707 16.2349 10.9702C16.5467 10.7697 16.97 10.7697 17.3042 10.9702C17.6161 11.1707 17.8389 11.5049 17.8389 11.8836C17.8389 12.2846 17.6161 12.6188 17.3042 12.8193C16.97 13.0198 16.5467 13.0198 16.2349 12.8193C15.9007 12.6188 15.7002 12.2846 15.7002 11.8836ZM16.4131 14.7575V17.5869H17.126V14.7575C17.1037 14.7575 17.0814 14.7352 17.0591 14.7352H16.4576C16.4354 14.7352 16.4131 14.7352 16.4131 14.7575ZM16.4131 18.6562V21.6861C16.4131 21.9979 16.168 22.2207 15.8784 22.2207C15.5665 22.2207 15.3437 21.9979 15.3437 21.6861V15.8046L14.3635 17.4977C14.2298 17.7651 13.8956 17.8542 13.6506 17.6983C13.3832 17.5646 13.2941 17.2304 13.4501 16.9853L14.7422 14.6684C15.0987 14.0669 15.7447 13.6659 16.4576 13.6659H17.0591C17.7721 13.6659 18.4181 14.0669 18.7746 14.6684L20.0667 16.9853C20.2227 17.2304 20.1335 17.5646 19.8662 17.6983C19.6211 17.8542 19.287 17.7651 19.1533 17.4977L18.1953 15.8046V21.6861C18.1953 21.9979 17.9503 22.2207 17.6607 22.2207C17.3488 22.2207 17.126 21.9979 17.126 21.6861V18.6562H16.4131Z",
    fill: "#1F59FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeCharacter);
export default __webpack_public_path__ + "static/media/badge-character.7471e4d92155ba899a2488637dcc36dd.svg";
export { ForwardRef as ReactComponent };